<template>
  <div class="search-page">
    <div class="searchContainer">
      <el-input v-model="keyword" class="searchBar" placeholder="请输入电影名称"></el-input>
      <el-button id="searchBtn" type="primary" circle @click="searchInfo"><i class="iconfont icon-r-find" style="font-size: 24px;"></i></el-button>
    </div>
    <div v-if="!isMobileLayout">
      <el-menu :default-active="$route.path"
               class="nav-menu"
               mode="horizontal"
               :router="true"
               background-color="#47464a"
               text-color="#fff"
               active-text-color="#ffd04b">
        <el-menu-item :index="item.path" v-for="item in menuList" :key="item.id">
          <i :class="item.icon" style="font-size: 36px"> </i>
                <b style="font-size: 22px"> {{ item.name }}</b>
        </el-menu-item>
      </el-menu>
    </div>
    <div v-else class="mobile-nav">
      <router-link
        v-for="item in menuList"
        :key="item.id"
        :to="item.path"
        class="mobile-nav-item"
        :class="{ 'is-active': $route.path === item.path }"
      >
        <i :class="item.icon"></i>
        <span>{{ item.name }}</span>
      </router-link>
    </div>
    <div>
      <router-view :keyword="keyword"></router-view>
    </div>
  </div>


</template>

<script>
export default {
  name: "Search",
  computed: {
    isMobileLayout() {
      return !!(this.$platform && this.$platform.isMobile)
    }
  },
  data() {
    return {
      menuList: [
        {
          id: '1',
          name: '电影',
          icon: "iconfont icon-r-paper",
          path: '/search/searchMovie'
        }
        // ,
        // {
        //   id: '2',
        //   name: '影院',
        //   path: '/search/searchCinema'
        // }
      ],
      keyword: this.$route.query.kw
    }
  },
  created() {

  },
  methods:{
    searchInfo(){
      this.$router.push(this.$route.path + '?kw=' + this.keyword)
    }
  },
  watch:{
    '$route'(){
      this.keyword = this.$route.query.kw
    }
  }
}
</script>

<style scoped>
.el-header{
  padding: 0px;
}

.nav-menu{
  display: flex;
  justify-content: space-around;
  font-size: 16px;
}

.el-menu-item{
  font-size: 16px;
}

.el-menu-item:hover{
  color: #FFFFFF !important;
}

.searchContainer{
  padding: 30px 0;
  display: flex;
  background: #47464a;
  justify-content: center;
}

.mobile-nav{
  display: none;
}

.searchBar{
  width: 630px;
}

.searchBar >>> input{
  padding-right: 0;
  border-radius: 50px;
  width: 630px;
  height: 50px;
}

#searchBtn{
  transform: translate(-100%, 0);
  width: 50px;
  height: 50px;
}

@media (max-width: 768px) {
  .search-page{
    overflow-x: hidden;
  }

  .searchContainer{
    padding: 20px 16px;
    align-items: center;
  }

  .searchBar{
    width: 100%;
    min-width: 0;
  }

  .searchBar >>> input{
    width: 100%;
    height: 44px;
    font-size: 15px;
  }

  #searchBtn{
    width: 44px;
    height: 44px;
  }

  .mobile-nav{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 12px;
    padding: 16px;
    background: #f4f5f7;
  }

  .mobile-nav-item{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 44px;
    padding: 10px 12px;
    border-radius: 12px;
    background: #ffffff;
    color: #47464a;
    text-decoration: none;
    box-shadow: 0 6px 18px rgba(31, 41, 55, 0.08);
  }

  .mobile-nav-item.is-active{
    background: #47464a;
    color: #ffd04b;
  }

  .mobile-nav-item i{
    font-size: 18px;
  }
}
</style>
